import cn from 'classnames';
import PropTypes from 'prop-types';

import { DIGITAL_DELIVERY_ONLY_MESSAGE } from 'constants/siteMessages';

import ContentBox from 'components/checkout/caap/ContentBox';
import css from 'styles/components/checkout/caap/spc/reviewitems/condensedDigitalItem.scss';
import {
  productName as cssProductName,
  imgBox,
  itemRow,
  last,
  productDetailsBox
} from 'styles/components/checkout/caap/spc/reviewItems.scss';

const CondensedDigitalItem = (params, { testId }) => {
  const { deliveryGroup, productsByLineItem } = params;
  const { lineItemIds } = deliveryGroup;

  return (
    <>
      <ContentBox isFirst={true} isNonRadio={true}>
        <div className={css.ddMessage}>
          <strong>Digital delivery: </strong>
          { DIGITAL_DELIVERY_ONLY_MESSAGE }
        </div>
      </ContentBox>
      {
        lineItemIds.slice().map((unmappedLineItemId, index) => {
          const mappedItem = productsByLineItem[unmappedLineItemId];
          const { productName, image: { url: imageUrl, alt: imageAlt }, lineItemId } = mappedItem;
          const isLast = index === lineItemIds.length - 1;
          const rowStyles = cn(itemRow, { [last]: isLast });

          return (
            <div className={rowStyles} key={lineItemId} data-test-id={testId('condensedDigitalItem')}>
              <div className={imgBox}>
                <img width="80" src={imageUrl} alt={imageAlt} />
              </div>

              <div className={productDetailsBox}>
                <div className={cssProductName}>
                  {productName}
                </div>
              </div>
            </div>
          );
        })
      }
    </>
  );
};

CondensedDigitalItem.contextTypes = {
  testId: PropTypes.func
};

export default CondensedDigitalItem;
